

function fPlayVideo() {

    const youtubeVideos = document.querySelectorAll(".js-youtube");

    if (youtubeVideos !== null) {

        let player = {};

        const onPlayerStateChange = function (event, i) {

            // this stops display of list of related videos
            if (event.data === YT.PlayerState.ENDED) {
                player[i].stopVideo();
            }
        };

        window.onYouTubeIframeAPIReady = () => {

            for (let i = 0; i < youtubeVideos.length; i += 1) {

                const playerFrame = youtubeVideos[i].querySelector('.js-youtube-player');

                player[i] = new YT.Player(playerFrame,
                    {
                        events: {
                            onStateChange: (e) => {

                                onPlayerStateChange(e,i);
                            }
                        },
                    });

                const oYTPlayVideoButton = youtubeVideos[i].querySelector('.js-play-video');

                oYTPlayVideoButton.addEventListener('click', () => {

                    const oYTVideoStill = youtubeVideos[i].querySelector('.js-video-still');
                    const oYTVideoMedia = youtubeVideos[i].querySelector('.js-video-media');
                    const oYTVideoContent = youtubeVideos[i].querySelector('.js-video-content');
                    const oYTVideoPlayer = youtubeVideos[i].querySelector('.js-youtube-player');

                    oYTVideoStill.classList.add('js-inactive');
                    oYTVideoContent.classList.add('js-inactive');
                    oYTVideoMedia.classList.add('js-active');

                    if (player[i] && typeof player[i].playVideo === 'function') {
                        player[i].playVideo();
                    }

                });

            }
        };

        const tag = document.createElement('script');
        tag.async = true;
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    const cloudinaryVideos = document.querySelectorAll(".js-cloudinary");

    if (cloudinaryVideos !== null) {

        for (let i = 0; i < cloudinaryVideos.length; i += 1) {

            const oCLPlayVideoButton = cloudinaryVideos[i].querySelector('.js-play-video');

            oCLPlayVideoButton.addEventListener('click', () => {

                const oCLVideoStill = cloudinaryVideos[i].querySelector('.js-video-still');
                const oCLVideoContent = cloudinaryVideos[i].querySelector('.js-video-content');
                const oCLVideoMedia = cloudinaryVideos[i].querySelector('.js-video-media');
                const oCLVideoPlayer = cloudinaryVideos[i].querySelector('.js-cloudinary-player');

                oCLVideoStill.classList.add('js-inactive');
                oCLVideoContent.classList.add('js-inactive');
                oCLVideoMedia.classList.add('js-active');
                oCLVideoPlayer.play();

            });

        }
    }
}
